import React from 'react'

const Achievement = () => {
  return (
    <div>
    <div className="achievement">
    <h1 className="text-center pt-5  text-dark">
    Our <span className='bold'> Achievements</span>
    </h1>
    <div classname="text-center">
  <img  src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/hero2.jpg" className='img-fluid' alt />
</div>

    <h3 className='text-center my-4 pb-4 text-white'>("Recievw award from the Honorable Chief Minister of Goa and the Governer of Sikkim")</h3>

    </div>
    <div className="text-center my-2">
  <img className="shake" src="https://rabsnetsolutions.com/experience-center/assets/img/membership/slider/arrow.png" alt="Shaking Image" />
</div>
    </div>
  )
}

export default Achievement
